
<template>
  <div class="home" :class="{ isIosx: isIosx }">
    <!-- 搜索栏 -->
    <van-sticky>
      <div
        class="homeNav"
        :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
      >
        <div class="navLeft">
          <img @click="goBack()" src="./../../assets/school/backh.png" />
          <img src="./../../assets/school/logo.png" />
        </div>
        <div class="navRight" @click="search()" v-if="searchList.length > 0">
          <img src="./../../assets/school/seach1.png" />
          <span v-if="searchList[0].list.length > 0">{{
            searchList[0].list[0].title.length > 8
              ? searchList[0].list[0].title.slice(0, 8) + "..."
              : searchList[0].list[0].title
          }}</span>
          <span v-else>请输入想要搜索的课程</span>
        </div>
      </div>
    </van-sticky>
    <!-- 内容 -->
    <div class="homeContent" v-if="loaded">
      <!-- tab -->
      <van-tabs
        v-model="active"
        line-width="16px"
        line-height="4px"
        title-inactive-color="#6E727A"
        title-active-color="#404247"
        animated
        @change="tabChange"
        sticky
        :offsetTop="isIosx ? '95px' : '90px'"
        v-if="tabList.length > 0"
      >
        <van-tab v-for="(k, z) in tabList" :key="z + '1'" :title="k.title">
          <!-- banner位 -->
          <div class="banner" v-for="(item, a) in bannerList" :key="a + '2'">
            <van-swipe
              class="my-swipe"
              :autoplay="3000"
              indicator-color="white"
              v-if="item.list.length > 0"
            >
              <van-swipe-item v-for="(i, aa) in item.list" :key="aa + '3'">
                <div class="bannerItem">
                  <img :src="i.img_url" @click="adSkip(i)" />
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <!-- 金刚区 -->
          <div
            class="kingKongArea"
            v-for="(item, b) in kingKongAreaList"
            :key="b + '11'"
            :class="{
              pagingKingKongArea: item.list.length > 1,
            }"
          >
            <van-swipe class="my-swipe" :loop="false" indicator-color="#4E7DF7">
              <van-swipe-item v-for="(ii, bb) in item.list" :key="bb + '4'">
                <van-grid :column-num="item.display_mode" :border="false">
                  <van-grid-item v-for="(j, bbb) in ii" :key="bbb + '5'">
                    <div class="kingKongAreaItem" @click="skip(j, 1)">
                      <img
                        class="kingKongAreaIcon"
                        v-if="j.icon_url"
                        :src="j.icon_url"
                      />
                      <img :src="j.img_url" />
                      <p>{{ j.title }}</p>
                    </div>
                  </van-grid-item>
                </van-grid>
              </van-swipe-item>
            </van-swipe>
          </div>
          <!-- 瓷片区 -->
          <div
            class="ceramicsArea"
            v-for="(item, c) in ceramicsAreaList"
            :key="c + 'c'"
          >
            <div v-if="item.oneList.length > 0">
              <!-- 第一行 -->
              <div class="ceramicsAreaOut" v-if="item.oneList.length > 0">
                <div
                  v-for="(i, cc) in item.oneList"
                  :key="cc + 'cc'"
                  :class="{
                    threeImg: item.oneList.length == 3,
                  }"
                >
                  <img :src="i.img_url" @click="skip(i, 2)" />
                </div>
              </div>
              <!-- 第二行 -->
              <div class="ceramicsAreaOut" v-if="item.twoList.length > 0">
                <div
                  v-for="(i, ccc) in item.twoList"
                  :key="ccc + 'ccc'"
                  :class="{
                    threeImg: item.twoList.length == 3,
                  }"
                >
                  <img :src="i.img_url" @click="skip(i, 2)" />
                </div>
              </div>
            </div>
          </div>
          <!-- 分割线 -->
          <div
            class="cutOffRule"
            v-if="
              ceramicsAreaList.length == 1 &&
              ceramicsAreaList[0].oneList.length < 1
            "
          ></div>
          <!-- 推荐课程 -->
          <div
            class="recommend"
            v-for="(item, d) in recommendList"
            :key="d + 'd'"
          >
            <div
              class="recommendContent"
              :style="{
                backgroundImage: 'url(' + item.style.background_url + ')',
              }"
            >
              <h3>
                <span>{{ item.title }}</span>
                <p @click="seeMore(item)">
                  更多
                  <img src="./../../assets/school/right.png" />
                </p>
              </h3>
              <div
                class="course"
                v-if="item.type == 1 && item.course_list.length > 0"
              >
                <CourseColum
                  :dataList="item.course_list"
                  v-if="item.display_mode == 1"
                ></CourseColum>
                <CourseRow
                  :dataList="item.course_list"
                  :isHome="true"
                  v-if="item.display_mode == 2"
                ></CourseRow>
              </div>
              <div
                class="teacher"
                v-if="item.type == 2 && item.lecturer_list.length > 0"
              >
                <van-tabs
                  v-model="recommendactive"
                  line-width="0"
                  swipe-threshold="1"
                  title-active-color="#404247"
                  title-inactive-color="#404247"
                >
                  <van-tab
                    v-for="(i, dd) in item.lecturer_list"
                    :key="dd + 'dd'"
                  >
                    <template #title>
                      <div class="teacherOut" @click="toLecturerDetails(i.id)">
                        <img v-if="i.head_pic" :src="i.head_pic" />
                        <img
                          v-else
                          src="./../../assets/school/defaultAvatar.png"
                        />
                        <p>{{ i.name }}</p>
                        <div>
                          <span>{{ i.desc }}</span>
                        </div>
                      </div>
                    </template>
                  </van-tab>
                </van-tabs>
              </div>
            </div>
            <div class="isolation"></div>
          </div>
          <!-- 更多 -->
          <div class="more" v-if="moreList.length > 0">
            <div v-for="(item, e) in moreList" :key="e + 'e'">
              <p class="tip">{{ item.title }}</p>
              <!--  -->
              <div class="moreContent">
                <span
                  v-for="(i, ee) in item.list"
                  :key="ee + 'ee'"
                  :style="{
                    borderColor: item.style.border_color,
                    borderWidth: item.style.border_size + 'px',
                    borderStyle: 'solid',
                  }"
                  @click="moreSkip(i)"
                >
                  {{ i.title }}
                  <img :src="item.style.icon_url" v-if="item.style.icon_url" />
                </span>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div v-else class="loading">
      <img src="./../../assets/school/loading.gif" />
      <p>加载中</p>
    </div>
  </div>
</template>

<script scoped>
import CourseColum from "./components/courseColumn.vue";
import CourseRow from "./components/courseRow.vue";
export default {
  data() {
    return {
      isIosx: false,
      loaded: false,
      id: 0,
      active: 0,
      recommendactive: 0,
      tabList: [],
      backgroundUrl: "",
      data: {},
      searchList: [],
      bannerList: [],
      kingKongAreaList: [],
      ceramicsAreaList: [],
      recommendList: [],
      moreList: [],
    };
  },
  components: { CourseColum, CourseRow },
  mounted() {
    this.isIosx = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getData();
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    // 搜索
    search() {
      let hotWordList = [];
      if (this.searchList[0]) {
        hotWordList = this.searchList[0].list;
      }
      this.$router.push({
        path: "/school/search",
        query: {
          hotWordList: JSON.stringify(hotWordList),
        },
      });
    },
    // tab
    tabChange(name) {
      this.id = this.tabList[name].id;
      this.getData();
    },
    getData() {
      this.bannerList = [];
      this.kingKongAreaList = [];
      this.ceramicsAreaList = [];
      this.recommendList = [];
      this.moreList = [];
      this.$api
        .get("school/member/tab/assembly", {
          tab_id: this.id,
        })
        .then((res) => {
          this.backgroundUrl = res.list.background_url;
          this.tabList = res.tab_list;
          this.data = res.list;
          // 搜索
          if (this.data.SouSuo) {
            this.searchList = this.data.SouSuo;
          }
          // banner
          if (this.data.GuangGao) {
            this.bannerList = this.data.GuangGao;
          }
          // 金刚区
          if (this.data.JinGangQu) {
            // kingKongAreaList
            let kingKongArea = {
              display_mode: 0,
              list: [],
            };
            this.data.JinGangQu.forEach((item, index) => {
              kingKongArea.display_mode = item.display_mode;
              if (item.list.length <= kingKongArea.display_mode * 2) {
                kingKongArea.list[0] = item.list;
              } else if (
                item.list.length <=
                kingKongArea.display_mode * 2 * 2
              ) {
                kingKongArea.list[0] = item.list.slice(
                  0,
                  kingKongArea.display_mode * 2
                );
                kingKongArea.list[1] = item.list.slice(
                  kingKongArea.display_mode * 2
                );
              } else if (
                item.list.length <=
                kingKongArea.display_mode * 2 * 3
              ) {
                kingKongArea.list[0] = item.list.slice(
                  0,
                  kingKongArea.display_mode * 2
                );
                kingKongArea.list[1] = item.list.slice(
                  kingKongArea.display_mode * 2,
                  kingKongArea.display_mode * 4
                );
                kingKongArea.list[2] = item.list.slice(
                  kingKongArea.display_mode * 4
                );
              } else if (
                item.list.length <=
                kingKongArea.display_mode * 2 * 4
              ) {
                kingKongArea.list[0] = item.list.slice(
                  0,
                  kingKongArea.display_mode * 2
                );
                kingKongArea.list[1] = item.list.slice(
                  kingKongArea.display_mode * 2,
                  kingKongArea.display_mode * 4
                );
                kingKongArea.list[2] = item.list.slice(
                  kingKongArea.display_mode * 4,
                  kingKongArea.display_mode * 6
                );
                kingKongArea.list[3] = item.list.slice(
                  kingKongArea.display_mode * 6
                );
              }
              this.kingKongAreaList[index] = kingKongArea;
            });
          }
          // 瓷片区
          if (this.data.CiPianQu) {
            // ceramicsAreaList
            let ceramicsArea = {
              oneList: [],
              twoList: [],
            };
            this.data.CiPianQu.forEach((item, index) => {
              if (item.list.length <= 3) {
                ceramicsArea.oneList = item.list;
              } else if (item.list.length == 4 || item.list.length == 5) {
                ceramicsArea.oneList = item.list.slice(0, 2);
                ceramicsArea.twoList = item.list.slice(2);
              } else if (item.list.length == 6) {
                ceramicsArea.oneList = item.list.slice(0, 3);
                ceramicsArea.twoList = item.list.slice(3);
              }
              this.ceramicsAreaList[index] = ceramicsArea;
            });
          }
          // 运营位推荐（课程/讲师）
          if (this.data.YunYingWei) {
            this.recommendList = this.data.YunYingWei;
          }
          // 更多推荐
          if (this.data.QiTaTuiJian) {
            this.moreList = this.data.QiTaTuiJian;
          }
          // 加载结束
          this.loaded = true;
        });
    },
    // banner跳转
    adSkip(data) {
      // console.log(data);
      switch (data.advertising_type) {
        case 1:
          // 商品广告
          let goodsHref = `xblife://home/goods_detail?goods_id=${data.shop_id}`;
          this.params(goodsHref, goodsHref, "goAdGoodsDetails");
          break;
        case 2:
          // 店铺广告
          let shopHref = `xblife://home/normal_shop_detail?shop_id=${data.shop_id}&type=${data.type}`;
          this.params(shopHref, shopHref, "goAdShopDetails");
          break;
        case 3:
          // 原生广告
          this.params(data.href, data.href, "goAdAppPage");
          break;
        case 5:
          // 展示型广告
          break;
        default:
          // 4 h5广告; 6 商学院广告
          // window.location.href = data.href;
          this.$router.push({
            path: "/school/tripartiteLink",
            query: {
              url: data.href,
            },
          });
      }
    },
    // 金刚区and瓷片区
    skip(data, type) {
      let only_key = "";
      if (type == 1) {
        only_key = "JinGangQu";
      } else {
        only_key = "CiPianQu";
      }
      switch (data.type) {
        case 1:
          // 课程列表
          this.toMoreCourse(data.id, true, only_key);
          break;
        case 2:
          // 讲师列表
          this.toMoreLecturer(data.id);
          break;
        case 3:
          // h5广告
          // window.location.href = data.href;
          this.$router.push({
            path: "/school/tripartiteLink",
            query: {
              url: data.href,
            },
          });
          break;
        case 4:
          // 一级分类
           this.$router.push({
            path: "/school/firstClassify",
            query: {
              api_category_id: data.id[0],
              title: data.title,
            },
          });
          break;
        default:
      }
    },
    // 更多推荐
    moreSkip(data) {
      // console.log(data);
      switch (data.type) {
        case 1:
          // 三级分类
          this.$router.push({
            path: "/school/secondClassify",
            query: {
              isHome: true,
              activeId: data.id,
              secondId: data.classify_list[1].id,
              title: data.classify_list[1].name,
            },
          });
          break;
        case 2:
          // 讲师列表
          this.toMoreLecturer(data.id);
          break;
        default:
      }
    },
    // 查看更多
    seeMore(item) {
      if (item.type == 1) {
        this.toMoreCourse(item, false);
      } else {
        this.toMoreLecturer(item.lecturer_ids);
      }
    },
    // 更多讲师
    toMoreLecturer(lecturer_ids) {
      this.$router.push({
        path: "/school/lecturerList",
        query: {
          lecturer_ids: JSON.stringify(lecturer_ids),
        },
      });
    },
    // 更多课程
    toMoreCourse(item, isMore, only_key) {
      this.$router.push({
        path: "/school/courseList",
        query: {
          isMore: isMore,
          only_key: only_key,
          data: JSON.stringify(item),
        },
      });
    },
    // 查看讲师详情
    toLecturerDetails(id) {
      this.$router.push({
        path: "/school/lecturerDetails",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style>
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loading img {
  width: 80px;
  height: 80px;
  margin: 200px 0 0;
}
.loading p {
  font-size: 12px;
  color: #9ca1ad;
}

.home {
  height: 100%;
  background-color: #ffffff;
}
.cutOffRule {
  height: 10px;
  background: #f7f8fc;
  margin-top: 24px;
}

/* 搜索栏 */
.homeNav {
  color: #404247;
  height: 22px;
  padding-top: 44px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 40px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.homeNav .navLeft {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 124px;
  height: 24px;
}
.homeNav .navLeft img:first-child {
  width: 24px;
  height: 24px;
}
.homeNav .navLeft img:last-child {
  width: 100px;
  height: 20px;
}
.homeNav .navRight {
  flex: 1;
  margin-left: 16px;
  height: 34px;
  background: rgba(247, 248, 252, 0.85);
  border-radius: 16px;
  display: flex;
  align-items: center;
}
.homeNav .navRight img {
  width: 16px;
  height: 16px;
  margin: 0 4px 0 16px;
}
.homeNav .navRight span {
  font-size: 14px;
  color: #9ca1ad;
}
/* 内容tab */
.homeContent {
  padding-bottom: 50px;
  border-radius: 16px 16px 0px 0px;
  position: relative;
  top: -16px;
  background-color: #ffffff;
}
.homeContent .van-tabs__wrap {
  /* margin: 0 16px; */
  padding: 0 16px 3px;
  background-color: #ffffff;
  border-radius: 16px 16px 0px 0px;
}
.homeContent .van-tab {
  flex: none;
  padding: 0;
  margin-right: 24px;
  font-size: 15px;
  margin-top: 3px;
}
.homeContent .van-tabs__line {
  background: linear-gradient(90deg, #4e7df7 0%, #86b4fc 100%);
  bottom: 19px;
}
.homeContent .van-tab--active {
  font-weight: 700;
}
/* banner位 */
.banner {
  /* margin: 24px 16px 0;
  height: 113px; */
}
.banner .bannerItem {
  margin: 10px 16px 0;
  height: 113px;
}
.banner img {
  width: 100%;
  height: 113px;
  border-radius: 6px;
}
/* 指示器样式 */
.banner .van-swipe__indicator {
  width: 6px;
  height: 6px;
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.5);
}
.banner .van-swipe__indicator--active {
  width: 16px;
  border-radius: 6px;
}
/* 金刚区 */
.kingKongArea {
  /* margin-top: 4px; */
}
/* 格子样式 */
.kingKongArea .van-grid-item__content {
  padding: 0;
}

.kingKongAreaItem {
  /* border: 1px solid blue; */
  padding-top: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
/* 超过一页 */
.pagingKingKongArea .van-swipe {
  padding-bottom: 17px;
}

.kingKongAreaItem .kingKongAreaIcon {
  height: 14px;
  width: auto;
  position: absolute;
  top: 19px;
  left: 50%;
  z-index: 99;
  border-radius: 0;
}
.kingKongAreaItem img {
  width: 40px;
  height: 40px;
  /* border-radius: 50%; */
}
.kingKongAreaItem p {
  font-size: 13px;
  font-weight: 400;
  color: #6e727a;
  margin-top: 8px;
}
/* 指示器样式 */
.kingKongArea .van-swipe__indicators {
  bottom: 2px;
}
.kingKongArea .van-swipe__indicator {
  width: 6px;
  height: 6px;
  opacity: 1;
  background-color: rgba(78, 125, 247, 0.5);
}
.kingKongArea .van-swipe__indicator--active {
  width: 16px;
  border-radius: 6px;
}
/* 瓷片区 */
.ceramicsArea {
  /* margin-top: 24px;
  background-color: #f7f8fc;
  padding: 13px 11px 13px 16px; */
}
.ceramicsArea > div {
  margin-top: 24px;
  background-color: #f7f8fc;
  padding: 13px 11px 13px 16px;
}
.ceramicsAreaOut {
  display: flex;
  justify-content: space-between;
}
.ceramicsAreaOut > div {
  flex: 1;
  margin-right: 5px;
  border-radius: 4px;
  height: 112px;
  overflow: hidden;
  margin-bottom: 5px;
}
.ceramicsAreaOut .threeImg {
  height: 74px;
}
.ceramicsAreaOut img {
  width: 100%;
  height: 100%;
}
/* 推荐课程 */
.recommend {
  background-color: #ffffff;
}
.recommend .recommendContent {
  padding-top: 24px;
  background-repeat: no-repeat;
  background-size: 100%;
  padding-bottom: 32px;
}
.recommend .isolation {
  height: 10px;
  background: #f7f8fc;
}
.recommendContent > h3 {
  margin: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  font-weight: 700;
  color: #333333;
}
.recommendContent > h3 p {
  font-size: 13px;
  font-weight: 400;
  color: #cacde0;
  display: flex;
  align-items: center;
}
.recommendContent > h3 img {
  width: 12px;
  height: 12px;
}
/* 课程 */
.recommend .course {
  margin: 20px 16px 0;
}
/* 讲师 */
.recommend .teacher {
  margin: 20px 0px 0;
}
.homeContent .recommend .van-tabs__wrap {
  margin: 0;
  padding: 0;
  border-radius: 0;
  height: 148px;
  background: transparent;
}
.homeContent .recommend .van-tabs__nav {
  background: transparent;
}
.recommend .van-tab {
  width: 118px;
  flex: none;
  border-radius: 4px;
  border: 1px solid #edf0fa;
  overflow: hidden;
  padding: 0;
  margin-left: 13px;
  margin-right: 0;
}
.recommend .van-tabs__nav--line.van-tabs__nav--complete {
  padding: 0 16px 0 3px;
}
.recommend .van-tab .van-tab__text {
  display: block;
  width: 100%;
  height: 100%;
}
.recommend .teacherOut {
  height: 146px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
}
.teacherOut img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  margin-top: 12px;
}
.teacherOut p {
  font-size: 15px;
  font-weight: 600;
  color: #404247;
  margin: 12px 12px 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.teacherOut > div {
  display: flex;
  height: 30px;
  align-items: center;
}
.teacherOut span {
  margin: 0 12px;
  font-size: 12px;
  font-weight: 400;
  color: #9ca1ad;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

/* 更多 */
.more {
  padding: 10px 16px 32px;
  background-color: #f7f8fc;
}
/* tip */
.more .tip {
  font-size: 14px;
  font-weight: 400;
  color: #9ca1ad;
  margin: 0;
  text-align: center;
  display: inherit;
}
.more .moreContent {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.more .moreContent span {
  background: #ffffff;
  border-radius: 16px;
  height: 32px;
  line-height: 32px;
  padding: 0px 16px;
  font-size: 13px;
  font-weight: 400;
  color: #404247;
  margin: 12px 9px 0;
  position: relative;
}
.more .moreContent span img {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: -10px;
}

.isIosx .homeNav {
  padding-top: 49px;
}
.isIosx .homeContent {
  padding-bottom: 84px;
}
</style>